/*
 * Vehicle Details tab of the Digital Twin Event History.
 *
 * Each inventoryInfoAuditLog UPDATE row carries only the values that were set,
 * so a field being present means it changed. kwh is the Project name, the
 * column the onboarding import and the critical configuration change both write.
 */
const UPDATE_FIELD_LABELS = [
  ["licencePlateNumber", "License Plate"],
  ["chassisNumber", "Chassis"],
  ["imei", "IMEI"],
  ["simNumber", "SIM"],
  ["kwh", "Project"],
  ["protocolName", "Protocol"],
  ["busType", "Bus Type"],
];

const hasValue = (value) => value !== null && value !== undefined && String(value).trim() !== "";

// [{ label: "Project", previous: "261kWh", value: "196kWh" }, ...] for the fields an
// UPDATE row set. previous comes from the API's previousValues (the value an earlier
// history row recorded) and is null when no earlier row did. Empty for other actions.
export const getUpdatedChanges = (event) =>
  event?.actionType === "UPDATE"
    ? UPDATE_FIELD_LABELS.filter(([key]) => hasValue(event?.[key])).map(([key, label]) => {
        const previous = event?.previousValues?.[key];
        return {
          label,
          previous: hasValue(previous) ? String(previous).trim() : null,
          value: String(event[key]).trim(),
        };
      })
    : [];

// The sentence above the changes. The changed values themselves are rendered
// separately (see getUpdatedChanges) so they stand apart from who made them.
export const buildVehicleDetailsDescription = (event) => {
  const who = `@${event?.createdByName}`;
  if (event?.actionType === "CREATE") return `${who} onboarded vehicle on platform`;
  if (event?.actionType === "UPDATE") {
    return getUpdatedChanges(event).length > 0 ? `${who} updated` : `${who} updated vehicle details`;
  }
  return `${who} ${String(event?.actionType ?? "").toLowerCase()} vehicle`;
};
